import Request from 'redux/config/services/Request'

const getGovernmentGrhPrograms = async () => {
  const response = await Request.get('/hr/government/grh_hr/programs/')
  return response.data
}

export const getTransitAgencies = async () => {
  const response = await Request.get('/hr/programs/transit_agencies/')
  const data = response.data
  return Array.isArray(data) ? data : data?.results || []
}

export const getCouponMerchants = async () => {
  const response = await Request.get(
    '/hr/programs/merchants/?mode_types=COUPON'
  )
  const data = response.data
  return Array.isArray(data) ? data : data?.results || []
}

export default getGovernmentGrhPrograms
